import React from "react";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "types/store";

import { Button, ButtonGroup, Icon, Accordion } from "aible";

import { Modal, Popover, OverlayTrigger, Overlay } from "react-bootstrap";

import LabeledToggle from "components/Inputs/Toggle/Toggle";
import { LineInput } from "components/Inputs/LineInput";
import TextInput from "components/Inputs/TextInput";

import Tooltip from "components/Inputs/Tooltip";

import ModelSelector from "components/ChatGPT/ModelSelector";
import BlueprintSave from "components/ChatGPT/BlueprintSave";
import BlueprintExport from "components/ChatGPT/BlueprintExport";
import BlueprintSelector from "components/ChatGPT/BlueprintSelector";
import UseCaseTypeSelector from "components/ChatGPT/UseCaseTypeSelector";
import FewShotView from "components/ChatGPT/FewShotView";
import SqlGenerationOptions from "components/ChatGPT/SqlGenerationOptions";
import LineageWarning from "components/ChatGPT/LineageWarning";

import DocumentSelector from "components/LanguageModelArtifact/DocumentSelector";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as globalReducer from "containers/App/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as reportReducer from "containers/Report/ReportReducer";
import * as viewReducer from "containers/View/reducer";
import * as languagageModelArtifactReducer from "containers/LanguageModelArtifact/reducer";

import Select, { components } from "react-select";

import { isEnabled } from "utils/featureFlags";

import styles from "./style.module.css";

const AddNewAutomaticQuestion = ({}) => {
  const dispatch = useDispatch();

  const [isAddPrompt, setIsAddPrompt] = useState(false);
  const [newPrompt, setNewPrompt] = useState(undefined);
  const [newMultiPrompt, setNewMultiPrompt] = useState(undefined);
  const [isBatchAddPrompt, setIsBatchAddPrompt] = useState(false);
  const [isOverwritePrompts, setIsOverwritePrompts] = useState(false);

  const replayPrompts = useSelector((state) => chatGPTReducer.getReplayPrompts(state));
  const updateReplayPrompts = (replayPrompts) => dispatch(chatGPTReducer.updateReplayPrompts(replayPrompts));

  const batchAddCustomReplayPrompts = (batchPrompts, isOverwritePrompts) =>
    dispatch(chatGPTReducer.batchAddCustomReplayPrompts(batchPrompts, isOverwritePrompts));

  const handleClose = () => {
    setIsAddPrompt(false);
    setIsBatchAddPrompt(false);
    setNewPrompt(undefined);
    setIsOverwritePrompts(false);
  };

  return (
    <div>
      {isAddPrompt ? (
        <div className={styles.addNewPrompt}>
          <div className={styles.addNewPromptTitle}>
            <div style={{ marginRight: "10px" }}>{"Add New Prompt"}</div>
            <ButtonGroup style={{ marginLeft: "10px" }}>
              <Button onClick={() => setIsBatchAddPrompt(false)} style={{ padding: "4px" }} active={!isBatchAddPrompt}>
                {"Add Single"}
              </Button>
              <Button onClick={() => setIsBatchAddPrompt(true)} style={{ padding: "4px" }} active={isBatchAddPrompt}>
                {"Add Multiple"}
              </Button>
            </ButtonGroup>
          </div>
          {isBatchAddPrompt ? (
            <textarea
              className={styles.settingPrompt}
              style={{ minWidth: "200px" }}
              value={newMultiPrompt}
              onChange={(val) => setNewMultiPrompt(val.currentTarget.value)}
            />
          ) : (
            <input
              placeholder="Question"
              value={newPrompt}
              onChange={(val) => {
                setNewPrompt(undefined);
                setNewPrompt(val.currentTarget.value);
              }}
              style={{ width: "200px", marginRight: "20px" }}
            />
          )}
          <Button onClick={() => handleClose()} style={{ padding: "4px", marginRight: "10px" }}>
            {"Cancel"}
          </Button>
          <Button
            type="primary"
            onClick={() => {
              if (isBatchAddPrompt) {
                batchAddCustomReplayPrompts(newMultiPrompt, isOverwritePrompts);
              } else {
                const foundPrompt = replayPrompts.find((p) => p?.prompt === newPrompt);
                if (foundPrompt === undefined) {
                  updateReplayPrompts([
                    ...replayPrompts,
                    { prompt: newPrompt, isCustom: true, autoAsk: true, isHidden: false }
                  ]);
                } else {
                  const retPrompts = [...replayPrompts];
                  const foundIndex = replayPrompts.findIndex((p) => p?.prompt === newPrompt);
                  const retPrompt = {
                    ...foundPrompt,
                    autoAsk: true,
                    isCustom: true,
                    isHidden: false
                  };
                  retPrompts.splice(foundIndex, 1, retPrompt);
                  updateReplayPrompts(retPrompts);
                }
              }
              handleClose();
            }}
            style={{ padding: "4px" }}
          >
            {"Save"}
          </Button>
          {isBatchAddPrompt ? (
            <div
              className={styles.addNewPromptCheckbox}
              onClick={() => {
                setIsOverwritePrompts(!isOverwritePrompts);
              }}
            >
              <input
                type="checkbox"
                style={{ marginRight: "10px", marginBottom: "2px" }}
                checked={isOverwritePrompts}
              />
              {"Overwrite Current"}
            </div>
          ) : null}
        </div>
      ) : (
        <div>
          <Button onClick={() => setIsAddPrompt(true)}>{"Manually Add A Question"}</Button>
        </div>
      )}
    </div>
  );
};

export default AddNewAutomaticQuestion;
